import playerReduxStore from '@player/src/store';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { MediaRegion, type IMediaManager, type VideoType } from '@src/slide/application/service/media-manager/media-manager.interface';
import { IPresentationModel } from '@src/slide/domain/ui-model/element-modeles/Interface/presentation-model.interface';

export default class SyncElementKey {
    private static presentationRef: IPresentationModel | null;
    private static mediaManager: IMediaManager;

    public static setMediaManagerDelegate(mediaManager: IMediaManager): void {
        if (SyncElementKey.mediaManager) return;
        SyncElementKey.mediaManager = mediaManager;
    }
    public static setPresentationRefDelegate(presentationRef: IPresentationModel): void {
        if (SyncElementKey.presentationRef) return;
        SyncElementKey.presentationRef = presentationRef;
    }

    public static findMediaById(mediaId: string): {mediaInstance: VideoType | null; pictureModelKey: string} | null {
        const currentSlideModel = this.getCurrentSlideModel();
        if (!currentSlideModel) return null;
        const pictureId = mediaId;
        const pictureModel = currentSlideModel.children
            .find(uiModel => uiModel.id === pictureId && uiModel.type === UIModelType.IMAGE);
        if (!pictureModel) return null;

        const pictureModelKey = pictureModel.key;
        const { mediaManager } = SyncElementKey;
        const mediaInstance = mediaManager?.getVideoInstanceByRegion(pictureModelKey, MediaRegion.PLAYER);
        return {
            mediaInstance,
            pictureModelKey,
        };
    }

    public static updateElementKey(pictureModelKey: string): void {
        const { mediaManager } = SyncElementKey;
        mediaManager?.updateElementKeyByRegion(pictureModelKey, MediaRegion.PLAYER);
    }

    public static playVideo(elementKey: string) {
        SyncElementKey.mediaManager.playVideoByRegion(elementKey, MediaRegion.PLAYER);
    }

    private static getCurrentSlideModel() {
        const control = playerReduxStore.getState().control as { currentPage: number };
        const presentationModel = SyncElementKey.presentationRef;
        return presentationModel?.children[control.currentPage];
    }
}
